module.exports = __webpack_public_path__ + "8c94309ffa47a60ec8722a173f9dfc59.svg";